import { render } from "./sidebar-item.vue?vue&type=template&id=677da446"
import script from "./sidebar-item.vue?vue&type=script&setup=true&lang=js"
export * from "./sidebar-item.vue?vue&type=script&setup=true&lang=js"

import "./sidebar-item.vue?vue&type=style&index=0&id=677da446&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.17_webpack@5.97.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"packages/client/src/core-components/sidebar/sidebar-item.vue"]])

export default __exports__